module.exports = __webpack_public_path__ + "img/image-comprehensive.6d999a2a.png";